import { Report199 } from "../../../components/borrowSystem/Report/Report199";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report199Container() {
  const titleName =
    "สรุปข้อมูลขนาดสถานประกอบกิจการที่กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report199 />
      <Footer />
    </div>
  );
}
